import * as Yup from "yup";

export const paymentMethodValidationSchema = Yup.object().shape({
  UPI: Yup.string().required("UPI is required"),
  BankAccountName: Yup.string().required("Bank Account Name is required"),
});
